import { List, fromJS, Map } from 'immutable';
import { promoShippingCost } from './ShippingMethodUtils';

export const METHOD_REQUEST_STATES = fromJS({
    ACTIVE: 'active',
    FAILED: 'failed',
    SUCCESS: 'success'
});


export const GET_SHIPPING_METHOD = '@@storefront/GET_SHIPPING_METHOD';
export const FETCH_SHIPPING_REWARDS = '@@storefront/FETCH_SHIPPING_REWARDS';
export const STORE_PROFILE_METHODS = '@@storefront/STORE_PROFILE_METHODS';
export const CREATE_PROFILE_ACTIVE = '@@storefront/CREATE_PROFILE_ACTIVE';
export const CREATE_PROFILE_FAILED = '@@storefront/CREATE_PROFILE_FAILED';
export const CREATE_PROFILE_SUCCESS = '@@storefront/CREATE_PROFILE_SUCCESS';
export const PROFILE_ALREADY_EXISTS = '@@storefront/PROFILE_ALREADY_EXISTS';
export const SET_SELECTED_SHIPPING_METHOD = '@@storefront/SET_SELECTED_SHIPPING_METHOD';
export const CLEAR_SHIPPING_PROFILES = '@@storefront/CLEAR_SHIPPING_PROFILES';
export const SET_SELECTED_SHIPPING_CART = '@@storefront/SET_SELECTED_SHIPPING_CART';
export const CLEAR_SHIPPING_DATA = '@@storefront/CLEAR_SHIPPING_DATA';
export const SET_SHIPPING_API_LAST_TRIGGERED = 'SET_SHIPPING_API_LAST_TRIGGERED';

export const UPDATE_PROMO_SHIPPING_COST = '@@storefront/UPDATE_PROMO_SHIPPING_COST';

const initialState = fromJS({
    selectedShippingMethod: { method: null },
    selectedShippingCart: { method: null },
    ishippingApiStatus: {
        isWorking: true,
        retryCount: 0,
        lastUserTriggered: false
    },
    profilekey: null
});
export const shippingMethodReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_PROFILE_ACTIVE: {
            return state.set(action.profile, fromJS({
                status: METHOD_REQUEST_STATES.get('ACTIVE')
            }))
                .setIn(['shippingApiStatus', 'lastUserTriggered'], false);
        }
        case STORE_PROFILE_METHODS: {
            return state.setIn([action.profile, 'methods'], fromJS(action.methods));
        }
        case CREATE_PROFILE_SUCCESS: {
            const updatedMethods = promoShippingCost(state, action.promoData);
            return state
                .setIn([action.profile, 'status'], METHOD_REQUEST_STATES.get('SUCCESS'))
                .setIn(['shippingApiStatus', 'isWorking'], true)
                .setIn(['shippingApiStatus', 'retryCount'], 0)
                .setIn(['shippingApiStatus', 'lastUserTriggered'], false) 
                .set('profileKey', null)
                .setIn([action.profile, 'methods'], fromJS(updatedMethods.getIn([action.profile, 'methods'])));
        }
        case CREATE_PROFILE_FAILED: {
            return state
                .set(action.profile, fromJS({
                    status: METHOD_REQUEST_STATES.get('FAILED'),
                    errorStatus: action.errorStatus,
                    errorMessage: action.errorMessage
                }))
                .setIn(['shippingApiStatus', 'isWorking'], false)
                .setIn(['shippingApiStatus', 'lastUserTriggered'], false)
                .updateIn(['shippingApiStatus', 'retryCount'], count => (count));
        }
        case SET_SELECTED_SHIPPING_CART: {
            const normalizeMethod = (method) => {
                if (List.isList(method)) return method.first();
                if (Array.isArray(method)) return fromJS(method[0]);
                if (method && typeof method === 'object') return fromJS(method);
                return null;
            };

            const methodPayload = action.payload.method || action.payload;
            const mode = action.payload?.mode || 'add';
            const newItem = normalizeMethod(methodPayload);
            if (!newItem) return state;

            const newToken = newItem.get('token');
            const selectedShippingCart = Map.isMap(state.get('selectedShippingCart'))
                ? state.get('selectedShippingCart')
                : new Map();

            let existingList = List.isList(selectedShippingCart.get('method'))
                ? selectedShippingCart.get('method')
                : List();

            const oldToken = state.getIn(['selectedShippingMethod', 'oldToken']);

            if (mode === 'edit' && oldToken && oldToken !== newToken) {
                const oldIndex = existingList.findIndex(item => item.get('token') === oldToken);
                if (oldIndex !== -1) {
                    const oldItem = existingList.get(oldIndex);
                    const oldQty = oldItem.get('quantity') || 1;

                    if (oldQty <= 1) {
                        existingList = existingList.delete(oldIndex);
                    } else {
                        existingList = existingList.set(
                            oldIndex,
                            oldItem.set('quantity', oldQty - 1)
                        );
                    }
                }
            }
            const newIndex = existingList.findIndex(item => item.get('token') === newToken);
            if (newIndex !== -1) {
                const existingItem = existingList.get(newIndex);
                const currentQty = existingItem.get('quantity') || 1;
                const newQty = mode !== 'refresh' ? currentQty + 1 : currentQty;
                existingList = existingList.set(
                    newIndex,
                    existingItem
                        .set('quantity', newQty)
                        .set('cost', newItem.get('cost'))
                        .set('displayName', newItem.get('displayName'))
                );
            } else {
                const fullItem = newItem.set('quantity', newItem.get('quantity') || 1);
                existingList = existingList.push(fullItem);
            }

            return state
                .set('selectedShippingCart', selectedShippingCart)
                .setIn(['selectedShippingCart', 'method'], existingList);
        }

        case SET_SELECTED_SHIPPING_METHOD: {
            const { method, oldToken } = action.payload;
            return state.set(
                'selectedShippingMethod',
                fromJS({
                    method,
                    oldToken: oldToken || null
                })
            );
        }
        case CLEAR_SHIPPING_PROFILES: {
            
            const selectedMethod = state.get('selectedShippingMethod');
            const selectedCart = state.get('selectedShippingCart');

            return fromJS({
                selectedShippingMethod: selectedMethod,
                selectedShippingCart: selectedCart
            });
        }
        case SET_SHIPPING_API_LAST_TRIGGERED: {
            const currentRetry = state.getIn(['shippingApiStatus', 'retryCount']) || 0;

            return state
                .setIn(['shippingApiStatus', 'lastUserTriggered'], action.payload.lastUserTriggered)
                .setIn(['shippingApiStatus', 'retryCount'], currentRetry + action.payload.retryCount);
        }
        case CLEAR_SHIPPING_DATA: {
            return initialState;
        }
        case PROFILE_ALREADY_EXISTS: {
            return state.set('profileKey', fromJS(action.profile));
        }
        default:
            return state;
    }
};


export const getShippingMethods = (shippingAddress, shippingRewardPayload, promoCode, isNewItem = false) => ({
    type: GET_SHIPPING_METHOD,
    shippingAddress,
    shippingRewardPayload,
    promoCode,
    isNewItem
});

export const storeProfileMethods = (profile, methods) => ({
    type: STORE_PROFILE_METHODS,
    profile,
    methods
});

export const createProfileActive = profile => ({
    type: CREATE_PROFILE_ACTIVE,
    profile
});

export const createProfileSuccess = (profile, methods, promoData) => ({
    type: CREATE_PROFILE_SUCCESS,
    profile,
    methods,
    promoData
});

export const createProfileFailed = (profile, errorStatus, errorMessage) => ({
    type: CREATE_PROFILE_FAILED,
    profile,
    errorStatus,
    errorMessage
});

export const profileAlreadyExists = profile => ({
    type: PROFILE_ALREADY_EXISTS,
    profile
});

export const clearShippingProfiles = () => ({
    type: CLEAR_SHIPPING_PROFILES
});
export const setSelectedShippingToken = (method, oldToken = null, isEditShippingMethodChanged = false) => ({
    type: SET_SELECTED_SHIPPING_METHOD,
    payload: {
        method: method.set('isEditShippingMethodChanged', isEditShippingMethodChanged),
        oldToken
    }
});

export const updatePromoShippingCost = promoData => ({
    type: UPDATE_PROMO_SHIPPING_COST,
    promoData
});

export const fetchShippingRewards = (capiClient, promoCode, orderData) => ({
    type: FETCH_SHIPPING_REWARDS,
    payload: { capiClient, promoCode, orderData }
});


export const selectedShippingCart = (method, mode = 'add') => ({
    type: SET_SELECTED_SHIPPING_CART,
    payload: {
        method: method,
        mode
    }
});

export const flushShippingDetails = () => ({
    type: CLEAR_SHIPPING_DATA
});

export const setShippingApiLastTriggered = (lastUserTriggered, retryCount) => ({
    type: SET_SHIPPING_API_LAST_TRIGGERED,
    payload: {
        lastUserTriggered,
        retryCount
    }
});


export const finishedGettingPromoRewards = (method, mode) => ({
    type: SET_SELECTED_SHIPPING_CART,
    payload: {
        method,
        mode
    }
});
